import React, { useEffect, useMemo, useState } from "react";
import { format } from "date-fns";

import { CommonDashboardWrapper } from "styles/GlobalStyles";
import { createdDateMenuItems } from "./data";
import { ContainerWrapper, TableWrapperStyles } from "./styled";

import {
  MagnifyingGlassOutlineRegularIcon,
  XOutlineRegularIcon
} from "assets/SVGComponents";
import RightIconOutlineRegularIcon from "assets/SVGComponents/RightIconOutlineRegularIcon";

import PillButtons from "components/Buttons/PillButtons";
import Input from "components/Input";
import CommonTable from "components/Tables/CommonTable";
import columns from "./historyColumns";

import { useDispatch, useSelector } from "react-redux";
import { useUsersSlice } from "./slice/index";
import { selectUserSearchHistory } from "./slice/selectors";
import { formatCustomRange, getLastNDaysRange } from "utils/helper";
import CustomDateModal from "components/CustomDateModal/index";

const SearchHistory = () => {
  const dispatch = useDispatch();
  const { actions } = useUsersSlice();
  const { loading, history, pagination } = useSelector(selectUserSearchHistory);

  const [userFilters, setUserFilters] = useState({
    createdAt: {},
    search: ""
  });
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [customDateRange, setCustomDateRange] = useState([null, null]);
  const [showDateModal, setShowDateModal] = useState(false);

  const tableColumns = useMemo(() => columns(), []);

  // --- Debounce search input ---
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchTerm);
    }, 300);
    return () => clearTimeout(handler);
  }, [searchTerm]);

  useEffect(() => {
    fetchSearchHistory();
  }, [userFilters, debouncedSearch]);

  const fetchSearchHistory = (page = 1) => {
    dispatch(
      actions.getSearchHistory({
        page: page,
        limit: 10,
        search: debouncedSearch,
        ...addDateFilter(userFilters.createdAt, "createdAt")
      })
    );
  };
  const updateDateFilter = (filterType, item) => {
    if (item.value === "custom") {
      setCustomDateRange([null, null]); // reset custom date range when opening modal
      setShowDateModal(true);
      return;
    }
    setUserFilters({
      ...userFilters,
      createdAt: {
        label: item.label,
        fromDate: getLastNDaysRange(item.value).fromDate,
        toDate: getLastNDaysRange(item.value).toDate
      }
    });
  };

  const addDateFilter = (filter, key) => {
    if (filter?.label && filter.label !== "Lifetime") {
      return { [key]: filter };
    }
    return {};
  };

  const updateCustomDateRange = (range) => {
    setCustomDateRange(range);
    setUserFilters({
      ...userFilters,
      createdAt: {
        label: formatCustomRange(range),
        fromDate: format(range[0], "yyyy-MM-dd"),
        toDate: format(range[1], "yyyy-MM-dd")
      }
    });
    setShowDateModal(false);
  };
  return (
    <ContainerWrapper className="search-history-container">
      <CommonDashboardWrapper>
        <div className="common-dashboard-wrapper">
          <h1 className="common-heading">Null Searches (Marketers)</h1>
        </div>

        <TableWrapperStyles>
          <div className="filter-bar">
            <div className="filter-bar-menus">
              <PillButtons
                placeholderText="User created at"
                statusPlaceholder="statusActive"
                mainLabelText={userFilters.createdAt.label}
                rightIcon={<RightIconOutlineRegularIcon />}
                menuItems={createdDateMenuItems}
                size="M"
                maxWidth="max-content"
                customClassName="status-width"
                onSelect={(item) => updateDateFilter("createdAt", item)}
              />
            </div>

            <Input
              id="searchUser"
              type="search"
              placeholder="Search for terms"
              leftIcon={<MagnifyingGlassOutlineRegularIcon />}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              size="S"
              className="search-input"
              rightIcon={<XOutlineRegularIcon />}
              handleClearSearch={() => setSearchTerm("")}
            />
          </div>

          <CommonTable
            data={history}
            columns={tableColumns}
            loading={loading}
            initialLoading={loading}
            total_count={pagination.total}
            page={pagination?.page || 1}
            limit={pagination?.limit || 10}
            tableWrapperStyles="table-wrapper-styles"
            tableClassName="comman-tabel-view"
            onPageChange={fetchSearchHistory}
          />
        </TableWrapperStyles>
      </CommonDashboardWrapper>
      <CustomDateModal
        show={showDateModal}
        showMonth={2}
        initialRange={customDateRange}
        onClose={() => setShowDateModal(false)}
        onApply={(range) => {
          setCustomDateRange(range);
          updateCustomDateRange(range);
        }}
      />
    </ContainerWrapper>
  );
};
export default SearchHistory;
